import React, { useCallback } from 'react';
import { Link } from 'gatsby';
import { animated, useSpring } from '@react-spring/web';
import { useClickOutside, mergeClassNames } from '../../../../../utils';
import translateEntryLink from '../../../../../utils/translateEntryLink';
import RichText from '../../../../generic/RichText';
import TransitionReveal from '../../../../generic/TransitionReveal';
import { CloseButton } from '../../../../generic/Button';
import styles from './index.module.scss';

export default function InfoCard({ isVisible, spot, closeFn, alternatePos = false }) {
  const heading = spot?.heading;
  const description = spot?.description?.description;
  let productLink = spot.product ? translateEntryLink(spot.product) : null;
  // const thumbnail = spot.product?.thumbnail;

  // this component triggers the provided closeFn when users clicks outside the
  // visible `InfoCard` it also drops triggering on clicks outside of info card
  // when transitioning out (closeFn already triggered) solves cases where
  // closeFn is a toggle fn and not strictly a close fn
  let closeHandler = useCallback(() => {
    closeFn(null);
  }, [closeFn]);
  let ref = useClickOutside(closeHandler);

  let contentSpringProps = useSpring({
    transform: `translateY(${isVisible ? 0 : 30}px)`,
    opacity: isVisible ? 1.0 : 0.0,
  });

  let closeButtonSpringProps = useSpring({ transform: `rotate(${isVisible ? 0 : -90}deg)` });

  return (
    <TransitionReveal
      className={mergeClassNames(styles.spotDescriptionCard, alternatePos ? styles.altPos : styles.defaultPos)}
      animationRef={null}
      isVisible={isVisible}
      initialTranslate={{ y: '60px', x: '0px' }}
    >
      <div ref={ref} className={mergeClassNames(styles.spotDescription)}>
        <animated.div style={contentSpringProps} ref={ref} className={styles.spotDescriptionContent}>
          <animated.div style={closeButtonSpringProps} className={styles.closeButton}>
            <CloseButton clickHandler={closeHandler} className={styles.button} isBig />
          </animated.div>
          <h3 key="header"> {heading} </h3>
          {/* This is on its way but needs more testing. */}
          {/* {thumbnail && <Image className={styles.thumbnail} fluid={thumbnail.fluid} alt={thumbnail.description} />} */}
          <RichText>{description}</RichText>
          {!productLink ? null : (
            <Link to={productLink} className={styles.link}>
              Go to product
            </Link>
          )}
        </animated.div>
      </div>
    </TransitionReveal>
  );
}
